import type { ReactNode } from "react";

interface Props {
  /** Adjusts bottom padding: when no `tabbar` the page has only the CTA. */
  tabbar?: boolean;
  children: ReactNode;
}

/**
 * Page wrapper. Sets up the full-bleed flex column the Mini App expects
 * and reserves space at the bottom for either tabbar (5-tab nav) or the
 * sticky CTA, never both stacked — the design always uses one or the other.
 */
export function TgPage({ tabbar = true, children }: Props) {
  return <div className={`tg-page${tabbar ? "" : " tg-page--no-tabbar"}`}>{children}</div>;
}
